import { useEffect, useRef, useState } from 'react';

/** Under this the work is done before anyone looks, and an indicator that brief reads as a glitch. */
const SAY_SOMETHING_AFTER_MS = 150;

/** Once on screen it stays long enough to read, however quickly the work finishes. */
const KEEP_IT_UP_FOR_MS = 450;

/** As long as `StatusLabel` waits before it shows a load. */
const SLOW_AFTER_MS = 1000;

type TOptions = {
  // For work that is usually instant, e.g. a query: nothing until it is slow, and gone as soon as it ends.
  onlyWhenSlow?: boolean;
};

const useDelayedIndicator = (isActive: boolean, { onlyWhenSlow = false }: TOptions = {}): boolean => {
  const [show, setShow] = useState(false);
  const shownAt = useRef(0);

  useEffect(() => {
    if (isActive) {
      const timer = window.setTimeout(
        () => {
          shownAt.current = performance.now();
          setShow(true);
        },
        onlyWhenSlow ? SLOW_AFTER_MS : SAY_SOMETHING_AFTER_MS
      );
      return () => window.clearTimeout(timer);
    }
    const left = shownAt.current + (onlyWhenSlow ? 0 : KEEP_IT_UP_FOR_MS) - performance.now();
    if (left <= 0) {
      setShow(false);
      return;
    }
    const timer = window.setTimeout(() => setShow(false), left);
    return () => window.clearTimeout(timer);
  }, [isActive]);

  return show;
};

export default useDelayedIndicator;
